import { LOGIN } from "./types";


export const loginAction = (data, onSuccess, onError) => {
    return {
        type: LOGIN,
        data,
        onSuccess,
        onError,
    };
};